import React from 'react';

import './emptyState.css';

export default (props) =>
  <div className='emptyState'>
    {/* <img src={props.imgUrl} /> */}
    <h2 className='center'>{props.title}</h2>
    <p className='center'>{props.text}</p>
  </div>
